module.exports = __webpack_public_path__ + "img/member.9dc8a3ad.png";